import { getSharePointResourceTokenPrefetchStateStore } from '../store/SharePointResourceTokenPrefetchStateStore';
import {
    SharePointResourceTokenPrefetchState,
    SharePointResourceTokenPrefetchStatus,
} from '../Schema/SharePointResourceTokenPrefetchState';
import { parse as parseUrl } from 'url';

const getAuthority = (url: string): string => {
    const webUri = parseUrl(url);
    return `${webUri.protocol}//${webUri.host}`;
};

// Returns the current (or default) status of sharepoint resource token
export function getSharePointResourceTokenPrefetchState(
    resourceUrl: string
): SharePointResourceTokenPrefetchState {
    const sharePointResourceTokenPrefetchStateStore = getSharePointResourceTokenPrefetchStateStore();
    const authorityUrl = getAuthority(resourceUrl);

    const currentResourceTokenPrefetchState = sharePointResourceTokenPrefetchStateStore.tokenStatusPerResource.get(
        authorityUrl.toLowerCase()
    );
    let resourceTokenState: SharePointResourceTokenPrefetchState;

    if (currentResourceTokenPrefetchState == null) {
        resourceTokenState = {
            status: SharePointResourceTokenPrefetchStatus.NotAvailable,
        };
    } else {
        resourceTokenState = currentResourceTokenPrefetchState;
    }

    return resourceTokenState;
}
